import type { ChannelId } from '@cyphex/types/common';

export const CHANNEL_KEYS = {
  all: ['channels'] as const,
  detail: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'detail', channelId] as const,
  tabs: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'tabs', channelId] as const,
  bookmarks: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'bookmarks', channelId] as const,
  members: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'members', channelId] as const,
  rail: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'rail', channelId] as const,
  mentionables: (channelId: ChannelId, query: string) =>
    [...CHANNEL_KEYS.all, 'mentionables', channelId, query] as const,
  topics: (channelId: ChannelId, query: string) =>
    [...CHANNEL_KEYS.all, 'topics', channelId, query] as const,
  /** Slow-mode cooldown + @channel rights. Short-lived by nature. */
  policy: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'policy', channelId] as const,
  moderation: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'moderation', channelId] as const,
  permalink: (channelId: ChannelId) => [...CHANNEL_KEYS.all, 'permalink', channelId] as const,
  /** This member's own notification level for the channel. */
  notifications: (channelId: ChannelId) =>
    [...CHANNEL_KEYS.all, 'notifications', channelId] as const,
  /** `#name` cross-reference autocomplete. Tenant-wide, so not channel-keyed. */
  lookup: (needle: string) => [...CHANNEL_KEYS.all, 'lookup', needle] as const,
} as const;
